import { useMemo } from 'react';
import type { ParameterOption } from '../../../shared/types/sharedParameter.types';

/**
 * Builds the dropdown option groups for connector binding fields. Insulation
 * fields lead with the Revit built-in property entry and drop any merged
 * option that duplicates it (case-insensitively).
 */
export function useConnectorParameterOptionGroups(dropdownParameterOptions: ParameterOption[]) {
  const insulationSpecOptions = useMemo(
    () => [
      { value: 'Insulation Type', label: 'Insulation Type (Revit built-in)', tooltip: 'Uses the built-in Revit Insulation Type value for the mapped PCF field.' },
      ...dropdownParameterOptions.filter(
        (option) => option.value.trim().toLowerCase() !== 'insulation type'
      ),
    ],
    [dropdownParameterOptions]
  );

  const insulationThicknessOptions = useMemo(
    () => [
      { value: 'Insulation Thickness', label: 'Insulation Thickness (Revit built-in)', tooltip: 'Uses the built-in Revit Insulation Thickness value for the mapped PCF field.' },
      ...dropdownParameterOptions.filter(
        (option) => option.value.trim().toLowerCase() !== 'insulation thickness'
      ),
    ],
    [dropdownParameterOptions]
  );

  const optionGroups = useMemo(
    () => ({
      shared: dropdownParameterOptions,
      insulationSpec: insulationSpecOptions,
      insulationThickness: insulationThicknessOptions,
    }),
    [insulationSpecOptions, insulationThicknessOptions, dropdownParameterOptions]
  );

  return { optionGroups };
}

export default useConnectorParameterOptionGroups;
